export default "__VITE_PUBLIC_ASSET__ae1a6b75__"